import React from 'react'
import { Business, InstantReviewSocialMedia, Step } from '../pages/ReviewFormPage'
import styles from '../styles/Reviews.module.scss'
import cn from 'classnames'
import { REWARDS_CDN_URL } from '../apollo/apollo-client'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useMutation } from '@apollo/client'
import { INSTANT_REVIEW_CLICK_MUTATION } from '../apollo/mutation/instant_review_google_click'

interface ThankYouHappyProps {
  business: Business
  review: string
  reviewId?: number

  setStep: (step: Step) => void
}

interface FeedbackImgProps {
  feedbackImgUrl: string
  socialMediaAmount: number
}

interface SocialMediaIconProps {
  socialMedia: InstantReviewSocialMedia
}

const FeedbackImg: React.FC<FeedbackImgProps> = ({ feedbackImgUrl, socialMediaAmount }) => {
  let img = <img src="/google_review.svg" alt="Google review"/>

  if (feedbackImgUrl) {
    img = <img src={REWARDS_CDN_URL + feedbackImgUrl} alt="Google review" />
  } else if (!socialMediaAmount) {
    img = <img src="/happy_thank_you.png" alt="Happy people" />
  }

  return img
}

const SocialMediaIcon: React.FC<SocialMediaIconProps> = ({ socialMedia }) => {
  if (!socialMedia?.iconUrl) {
    return null
  }

  return (
    <span>
      <img className={styles.social_img} src={REWARDS_CDN_URL + socialMedia?.iconUrl } alt={socialMedia?.name + ' icon'} />
    </span>
  )
}

export const ThankYouHappyStep: React.FC<ThankYouHappyProps> = ({ business, setStep, review, reviewId }) => {
  const [instantReviewClick, { loading: instantReviewClickLoading }] = useMutation(INSTANT_REVIEW_CLICK_MUTATION)

  const giveReview = async (social: InstantReviewSocialMedia) => {
    if (!reviewId) {
      window.open(social?.url,'_self')
    } else {
      await instantReviewClick({
        variables: {
          id: social?.id,
          reviewId,
        }}
      ).then(() => {
        window.open(social?.url,'_self')
      }).catch((e) => {
        console.log('give review error', e)
      })
    }
  }

  const socialMedia = business.instantReviewSocialMedia?.sort((a, b) => +a.position! - +b.position!)
  const socialMediaAmount = business.instantReviewSocialMedia?.length

  return (
    <div className={styles.thank_you}>
      <FeedbackImg
        feedbackImgUrl={business?.instantReviewFeedbackImgUrl}
        socialMediaAmount={socialMediaAmount}
      />

      {
        !!socialMediaAmount ? (
          <>
            <p className={styles.thank_you_text}>
              Please support us!
            </p>

            <p className={cn(styles.thank_you_text, styles.thank_you_text_marginBottom)}>
              Your feedback was copied. <br/>
              Please paste as review.
            </p>

            <div className={business.businessFeatures.instantReviewsAdBlock ? styles.thank_you_media_list : ''}>
              {
                socialMedia?.map((item) => {
                  return (
                    <CopyToClipboard text={review} key={item?.name}>
                      <button
                        onClick={() => giveReview(item)}
                        disabled={instantReviewClickLoading}
                        className={cn(styles.social_btn)}
                      >
                        <SocialMediaIcon socialMedia={item} /> { item?.name }
                      </button>
                    </CopyToClipboard>
                  )
                })
              }
            </div>

            <button onClick={() => setStep('not-contact-me')}
              className={styles.thank_you_link}
            >
              Maybe later
            </button>
          </>
        ) : (
          <p className={styles.thank_you_text}>
            Thanks, we really appreciate your <br/>
            feedback
          </p>
        )
      }
    </div>
  )
}